export function getRandomAmount(min = 1000.00, max = 9999.99) {
    const random = Math.random() * (max - min) + min;
    return parseFloat(random.toFixed(2)); // Keep two decimal places
}

export function getRandomFourDigit() {
    return Math.floor(Math.random() * 9000) + 1000;
}

export function formatNumber(value: number) {
    return value.toFixed(2);
}

export function isNumeric(value: any) {
    return !isNaN(value) && !isNaN(parseFloat(value));
}